import { render, staticRenderFns } from "./_product.vue?vue&type=template&id=44ec35b4&"
import script from "./_product.vue?vue&type=script&lang=js&"
export * from "./_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductDetailsPage: require('/var/www/fs-store/components/ProductDetailsPage.vue').default})
